import { createRequest } from '@savgroup-front-common/core/services/request';

export enum USERS_ACTION_TYPE {
  GET_USER_BY_ID = 'USERS/GET_USER_BY_ID',
}

export const GET_USER_BY_ID = createRequest(USERS_ACTION_TYPE.GET_USER_BY_ID);
